import { faqLinks } from '@/mocks/footer';
import { navItems, siteName, editionInfo } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 dark:bg-primary-900">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50 dark:text-foreground-950">
                  {siteName}
                </span>
                <span className="mt-0.5 font-label text-[10px] tracking-[0.28em] text-background-50/60 dark:text-foreground-950/60">
                  DAILY 18:00
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-50/75 dark:text-foreground-950/75">
              每天 18:00 准时汇总一次，把新料、补充和反转折点排在同一条时间线上。想让哪些内容进入六点场，可以在值班精选下留言线索。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="flex h-7 items-center gap-1.5 rounded-md bg-background-50/10 px-2.5 font-label text-xs text-background-50/80 dark:text-foreground-950/80">
                <i className="ri-timer-flash-line" />
                {editionInfo.slot}
              </span>
              <span className="flex h-7 items-center gap-1.5 rounded-md bg-background-50/10 px-2.5 font-label text-xs text-background-50/80 dark:text-foreground-950/80">
                <i className="ri-bookmark-line" />
                {editionInfo.episode}
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-background-50 dark:text-foreground-950">站内分区</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="font-label text-sm text-background-50/75 transition-colors hover:text-background-50 dark:text-foreground-950/75 dark:hover:text-foreground-950"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-sm font-bold text-background-50 dark:text-foreground-950">常见问题</h3>
            <ul className="mt-4 flex flex-col gap-3">
              {faqLinks.map((faq) => (
                <li key={faq.q}>
                  <p className="font-label text-sm text-background-50/90 dark:text-foreground-950/90">{faq.q}</p>
                  <p className="mt-1 text-xs leading-relaxed text-background-50/65 dark:text-foreground-950/65">
                    {faq.a}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-9 flex flex-col gap-3 border-t border-background-50/15 pt-5 dark:border-foreground-950/15 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-50/60 dark:text-foreground-950/60">
            © 2026 {siteName} · 内容均为站内整理的公开讨论，标注「待核实」的说法请自行判断。
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="flex items-center gap-1.5 font-label text-xs text-background-50/60 dark:text-foreground-950/60">
              <i className="ri-shield-check-line" />
              核实优先，不抢首发
            </span>
            <span className="flex items-center gap-1.5 font-label text-xs text-background-50/60 dark:text-foreground-950/60">
              <i className="ri-time-line" />
              每日 18:00 更新
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}